import { GetMaskingService } from './../../adapters/getMasking.service';
import { Component, OnInit, ViewChild, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { TiscoModalComponent } from 'src/app/shared/component/tisco-modal/tisco-modal.component';
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { GetInsuranceRenewQRPayment } from '../../adapters/getInsuranceRenewQRPayment.service';
import { CreateCustomerAccountService } from "../../adapters/createCustomerAccount.service";
import { CreateOrderTransactiontService } from "../../adapters/createOrderTransaction.service";
import { GenVoucherNumberService } from "src/app/adapters/genVoucherNumber.service";
import { CreatePaymentDetailService } from "../../adapters/createPaymentDetail.service";
import { UpdateCustomerPaymentQRSercice } from "../../adapters/updateCustomerPaymentQR.service";
import { GetQrBarcodePayment } from '../../adapters/getQrBarcodePayment.service';
import { SendLineMessageService } from '../../adapters/sendLineMessage.service';
import { GetWrapUpQrPayment } from '../../adapters/getWrapUpQrPayment.service';
import { CallTss } from '../../adapters/callTss.service';

import { GetMotorPaymentSummary } from '../../adapters/getMotorPaymentSummary.service';
import { GetNonMotorPaymentSummary } from '../../adapters/getNonMotorPaymentSummary.service';
import { ConstantsService } from '../../shared/service/constants/constants.service';
import { BaseComponents } from '../../base.component';
import { ConvertTimestamp } from '../../adapters/convertTimestamp.service';
import { environment } from '../../../environments/environment';
import { GetLineTokenService } from 'src/app/adapters/getLineToken.service';
import liff from '@line/liff';
declare var window: any;

@Component({
    selector: "app-qr-barcode",
    templateUrl: "./qr-barcode.component.html",
    styleUrls: ["./qr-barcode.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QrBarcodeComponent extends BaseComponents implements OnInit {
  @ViewChild(TiscoModalComponent) modal;

  logger_session = "Display Payment (QR Barcode):";
  logger_text = "";

  payment_amount: any;
  motor_ucid: any;
  motor_letter_ucid: any;
  product_type: number;
  comcode: string;
  isMotor: boolean;

  theme = signal<string>('');
  displayLayout = signal<boolean>(true);
  liff_id: any;
  // lineId: string;
  profile: any;
  url: any;

  //Motor
  data_1_2936: any;
  data_1_2937: any;  //letter

  //Nonmotor
  data_1_2953: any;
  data_1_2954: any;  //letter

  //common data
  data_1_9: any;
  data_1_1424: any;
  data_1_1401_1565: any;
  voucherNumber: any;
  data_order_voucher: any;
  data_payment_detail: any;
  data_update_status: any;
  data_qr_barcode_payment: any;
  data_wrap_up: any;
  data_tss: any;
  rm_channel_id: any;

  //set console.log
  console_print: boolean = true;
  // access_token_line : string = ""
  liff_channel_id : string = "";
  channel_line_id : string = "";
  subChannel : number | null = null;
  isCompulsory: boolean = false;
  constructor(
    protected injectorObj: Injector,
    private route: ActivatedRoute,
    private getInsuranceRenewQRPayment: GetInsuranceRenewQRPayment,
    private createCustomerAccountService: CreateCustomerAccountService,
    private createOrderTransactiontService: CreateOrderTransactiontService,
    private genVoucherNumberService: GenVoucherNumberService,
    private createPaymentDetailService: CreatePaymentDetailService,
    private updateCustomerPaymentQRSercice: UpdateCustomerPaymentQRSercice,
    private getQrBarcodePayment: GetQrBarcodePayment,
    private sendLineMessageService: SendLineMessageService,
    private getWrapUpQrPayment: GetWrapUpQrPayment,
    private callTss: CallTss,
    private getMotorPaymentSummary: GetMotorPaymentSummary,
    private getNonMotorPaymentSummary: GetNonMotorPaymentSummary,
    private ConstantsService: ConstantsService,
    private convertTimestamp: ConvertTimestamp,
    private getMaskingService : GetMaskingService,    
    private getLineTokenService : GetLineTokenService,
    private router: Router,
  ) { 
    super(injectorObj);
  }

  async ngOnInit() {
    this.logger_text = `${this.logger_session} Start`;
    this.logger.info(this.logger_text);
    this.route.queryParams.subscribe(params => {
      this.logger_text = `${this.logger_session} Parameters`;
      this.logger.info(this.logger_text, params);
      this.payment_amount = params["amount"] || '';
      this.motor_ucid = params["dataucid"] || '';
      this.motor_letter_ucid = params["letterucid"] || '';
      this.product_type = params["product_type"] || '';
      this.rm_channel_id = params['rm_channelId'];
      this.comcode = params['comcode'];
      this.liff_id = params['appRef'] || '';
      this.liff_channel_id = params['liff_channel_id'];
      this.channel_line_id = params['channel_line_id'];
      this.subChannel = params['subchannel'] ?  parseInt(params['subchannel']) : null;
      // this.lineId = params['user_id'] || ''
    });

    // await liff.init({ liffId: this.liff_id })
    // if (liff.isLoggedIn() == false && liff.isInClient() == false) {
    // liff.login({ redirectUri: this.url });
    // }
    try {
      // if(environment.production){
      //   await liff.init({ liffId : this.liff_id});
      //   if(liff.isLoggedIn() === false && liff.isInClient() === false){
      //     this.logger.info(['login liff callback path:', window.location.href]);
      //       liff.login({ redirectUri: window.location.href })
      //   }else{
      //     this.access_token_line = await liff.getAccessToken();
      //     this.logger.debug(['access_token_line:', this.access_token_line]);
      //   }
      // }
      // this.access_token_line = await this.getLineTokenService.exec(liff,this.liff_id,this.logger)
      // this.profile = await liff.getProfile();
      // this.logger_text = `${this.logger_session} getProfile`;
      // this.logger.info(this.logger_text, this.profile);
      // this.lineId = this.profile.userId;
    }
    catch (error) {
      // this.lineId = 'U92fc26c257f888f5aa4a6ce1690c16c1';
      this.logger_text = `${this.logger_session} Get Profile Error`;
      this.logger.error(this.logger_text, error?.message);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.logger_text,'error line_token qr-barcode :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.logger_text} error qr-barcode ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
    };

    this.logger_text = `${this.logger_session} RAW INPUT    
    payment_amount: ${this.payment_amount}
    motor_ucid: ${this.motor_ucid}
    motor_letter_ucid: ${this.motor_letter_ucid}
    product_type : ${this.product_type}
    rm_channel_id : ${this.rm_channel_id}`;
    this.logger.info(this.logger_text);

    if (this.payment_amount !== '' && this.motor_ucid !== '' && this.product_type !== null) {
      this.theme.set(this.comcode);
      if (this.product_type == this.ConstantsService.MOTOR) {
        if (this.motor_letter_ucid !== '') {
          this.logger_text = `${this.logger_session} Motor Step ucid`;
          this.logger.info([this.logger_text, this.motor_ucid, "letter ucid", this.motor_letter_ucid]);
          this.isMotor = true;
          this.startMotorInsure();
        }
      } else {
        this.logger_text = `${this.logger_session} Non-Motor Step ucid`;
        this.logger.info([this.logger_text, this.motor_ucid]);
        this.isMotor = false;
        this.startNonMotorInsure();
      }
    } else {
      this.logger_text = `${this.logger_session} Request data null`;
      this.logger.error(this.logger_text);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    }
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  startMotorInsure() {
    this.logger_text = `${this.logger_session} Start Motor Step`;
    this.logger.info(this.logger_text);
    this.getInsuranceRenewQRPayment
      .exec({
        product_type: this.ConstantsService.MOTOR, //  1 motor or 2 non-motor
        renewMotorUCID: this.motor_ucid,
        renewMotorLetterUCID: this.motor_letter_ucid
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "Get insurance Renew QR Payment"]);
        this.logger_text = `${this.logger_session} getInsuranceRenewQRPayment`;
        this.logger.debug(this.logger_text, res);

        this.data_1_2936 = res.result_1_2936.response_data[0];
        this.data_1_2937 = res.result_1_2937.response_data[0];
        this.data_1_9 = res.result_1_9.response_data[0];
        this.data_1_1424 = res.result_1_1424.response_data[0];
        this.isCompulsory = res.isCompulsory;
        this.logger.info([this.logger_text, this.motor_ucid, "Get create account"]);
        // ใช้ 1_2937._40 แทน 1_2936._40 เพื่อไปบันทึกที่ customer account เท่านั้น (เพราะ 1_2936._16055 คือค่าที่ = 1_2937._40)        
        let body = this.createBodyAccount({...this.data_1_2936,"_40":this.data_1_2937._40}, this.data_1_9,"motor");
        this.logger_text = `${this.logger_session} createCustomerAccountService Body`;
        let showlogcreateBody = {
          ...body,
          registrationNumber : this.getMaskingService.maskingData(body["registrationNumber"]),
          fistName : this.getMaskingService.maskingData(body["firstName"]),
          lastName : this.getMaskingService.maskingData(body["lastName"]),
          mobile : this.getMaskingService.maskingData(body["mobile"])
        }
        this.logger.info(this.logger_text, showlogcreateBody);
        this.logger.debug(this.logger_text, body);
        return this.createCustomerAccountService.exec(body, "");
      })
      .then(async (res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "create account res", res]);
        // this.logger_text = `${this.logger_session} createCustomerAccountService res`;
        // this.logger.debug(this.logger_text, res);

        this.data_1_1401_1565 = res.data;

        if (this.data_1_1401_1565.accountIdentityUCID != undefined && this.data_1_1401_1565.identityUCID != undefined) {
          // data_1_2936, 1_1401_1_1565, data_1_1424 motor
          this.logger.info([this.logger_text, this.motor_ucid, "create order transaction"]);
          let body = await this.createBodyOrderTransactionAll(this.data_1_2936, this.data_1_1401_1565, this.data_1_1424);
          this.logger_text = `${this.logger_session} createOrderTransactiontService body`;
          this.logger.info(this.logger_text, body);
          return this.createOrderTransactiontService.exec(body, "");
        } else {
          this.logger_text = `${this.logger_session} createCustomerAccountService error`;
          this.logger.error(this.logger_text);
          this.logger.error("error createBodyAccount: ", this.createBodyAccount({...this.data_1_2936,"_40":this.data_1_2937._40}, this.data_1_9,"motor"));
          this.modal.show({
            title: 'Header Information',
            callBack: 'home',
            body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
          });
          return;
        }
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "create order transaction res", res]);
        // this.logger_text = `${this.logger_session} createOrderTransactiontService res`;
        // this.logger.debug(this.logger_text, res);

        this.data_order_voucher = res;

        if (this.data_order_voucher.voucherNumber != undefined && this.data_order_voucher.orderTransactionUCID != undefined) {
          this.logger.info([this.logger_text, this.motor_ucid, "create payment detail"]);
          let body = this.createBodyPaymentDetail(this.data_1_1401_1565, this.data_1_1424, this.data_order_voucher, this.payment_amount);

          this.logger_text = `${this.logger_session} createPaymentDetailService body`;
          let showBody = {
            identityUCID:body.identityUCID,
            productInfoUCID:body.productInfoUCID,
            accountIdentityUCID:body.accountIdentityUCID,
            voucherNumber:body.voucherNumber,
            orderTransactionUCID:body.orderTransactionUCID,
            paymentMethod:body.paymentMethod,
            paymentChannel:body.paymentChannel,
            paymentProvider:body.paymentProvider,            
            paymentStatus:body.paymentStatus,
            renewMotor:body.renewMotor
          }
          this.logger.info(this.logger_text, showBody);

          return this.createPaymentDetailService.exec(body);
        } else {
          this.logger_text = `${this.logger_session} createOrderTransactiontService error`;
          this.logger.error([this.logger_text, res]);
          // this.logger.error("error createOrderTransactiontService: ", this.createBodyOrderTransactionAll(this.data_1_2936, this.data_1_1401_1565, this.data_1_1424));
          this.modal.show({
            title: 'Header Information',
            callBack: 'home',
            body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
          });
          return;
        }
      }).then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "create order transaction res", res]);
        // this.logger_text = `${this.logger_session} createPaymentDetailService res`;
        // this.logger.debug(this.logger_text, res);

        this.data_payment_detail = res;

        let f09_status = 52;
        //step 4
        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 52"]);
        let body = this.createBodyUpdateCustomerAccount(this.data_1_2937, this.payment_amount, this.motor_ucid, this.product_type, f09_status, this.subChannel);

        this.logger_text = `${this.logger_session} updateCustomerPaymentQRSercice body`;
        let showlogBody = {          
          status:body.status,          
          motor_ucid:body.motor_ucid,
          product_type:body.product_type
        }
        this.logger.info(this.logger_text, showlogBody);

        return this.updateCustomerPaymentQRSercice.exec(body, "");
      }).then(res => {
        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 52 res", res]);
        // this.logger_text = `${this.logger_session} updateCustomerPaymentQRSercice res`;
        // this.logger.debug(this.logger_text, res);

        this.logger.info([this.logger_text, this.motor_ucid, "get agent"]);
        let body = this.createBodyGetDataWrapUp(this.data_1_2936._12201, this.data_1_2936._16055, 'M_MOTOR');

        this.logger_text = `${this.logger_session} getWrapUpQrPayment body`;
        this.logger.info(this.logger_text, body);

        return this.getWrapUpQrPayment.exec(body);
      })
      .then(async (res: any) => 
      {
        // this.logger_text = `${this.logger_session} getWrapUpQrPayment res`;
        // this.logger.debug(this.logger_text, res);

        this.data_wrap_up = res.data;

        let agent1 = null;
        let agent2 = null;
        if (res.data != null) {
          agent1 = this.data_wrap_up._11784;
          agent2 = this.data_wrap_up._16220;
        }

        this.logger.info([this.logger_text, this.motor_ucid, "get agent res", "agent 1 is not null", agent1 != null? true: false]);
        this.logger.info([this.logger_text, this.motor_ucid, "get agent res", "agent 2 is not null", agent2 != null? true: false]);

        this.logger.info([this.logger_text, this.motor_ucid, "get payment summary"]);
        let body_get_payment_summary = this.createBodyGetPaymentSummary();

        this.logger_text = `${this.logger_session} getMotorPaymentSummary body`;
        this.logger.info(this.logger_text, body_get_payment_summary);

        const responseGetPaymentSummary = await this.getMotorPaymentSummary.exec(body_get_payment_summary);

        this.logger_text = `${this.logger_session} getMotorPaymentSummary res`;
        this.logger.debug(this.logger_text, responseGetPaymentSummary);

        this.logger.info([this.logger_text, this.motor_ucid, "update f09"]);
        let body = await this.createBodyF09Update(this.data_1_2936, this.data_1_2937, agent1, agent2, responseGetPaymentSummary);

        this.logger_text = `${this.logger_session} callTss body`;
        this.logger.info(this.logger_text, body);

        return this.callTss.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "update f09 res", res]);
        // this.logger_text = `${this.logger_session} callTss res`;
        // this.logger.debug(this.logger_text, res);

        this.data_tss = res;

        let f09_status = 51;
        try {
          if (res.response_code == "40000") {
            f09_status = 50;
          }
        } catch (e) {

        }
        //step 4
        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 50/51"]);
        let body = this.createBodyUpdateCustomerAccount(this.data_1_2937, this.payment_amount, this.motor_ucid, this.product_type, f09_status, this.subChannel);

        this.logger_text = `${this.logger_session} createBodyUpdateCustomerAccount body`;
        this.logger.debug(this.logger_text, body);

        return this.updateCustomerPaymentQRSercice.exec(body, "");
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 50/51 res", res]);
        // this.logger_text = `${this.logger_session} createBodyUpdateCustomerAccount res`;
        // this.logger.debug(this.logger_text, res);

        this.data_update_status = res;
        this.logger.info([this.logger_text, this.motor_ucid, "get QR payment link"]);

        let name = `${this.data_1_2936._1291} ${this.data_1_2936._1292}`;
        let service_comp_code = `Service code : 00 / Comp Code : 10`;
        let body = this.createBodyQrBarcode(this.data_1_2936._16278, this.data_1_2936._6260, this.data_1_2936._6261, name, service_comp_code);

        this.logger_text = `${this.logger_session} getQrBarcodePayment body`;
        let showlogBody = {
          channel_app:body.channel_app,
          payment_channel:body.payment_channel,
          tax_id:this.getMaskingService.maskingData(body.tax_id),
          service_id:body.service_id,          
          ref1:body.ref1,
          ref2:body.ref2,
          name:this.getMaskingService.maskingData(body.name),
          service_comp_code:body.service_comp_code
        }
        this.logger.info(this.logger_text, showlogBody);

        return this.getQrBarcodePayment.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "get QR payment link res", res]);
        // this.logger_text = `${this.logger_session} getQrBarcodePayment res`;
        // this.logger.debug(this.logger_text, res);

        this.data_qr_barcode_payment = res;

        this.logger.info([this.logger_text, this.motor_ucid, "send line 006"]);
        let body = this.createBodyLine006();

        this.logger_text = `${this.logger_session} sendLineMessageService body`;
        this.logger.info(this.logger_text, body);

        return this.sendLineMessageService.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "send line 006 res", res]);
        // this.logger_text = `${this.logger_session} sendLineMessageService res`;
        // this.logger.debug(this.logger_text, res);

        this.logger.info([this.logger_text, this.motor_ucid, "send line 008"]);
        let body = this.createBodyLine008(this.data_qr_barcode_payment.message.pmt_link);

        this.logger_text = `${this.logger_session} sendLineMessageService body`;
        this.logger.info(this.logger_text, body);

        return this.sendLineMessageService.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "send line 008 res", res]);
        // this.logger_text = `${this.logger_session} sendLineMessageService res`;
        // this.logger.debug(this.logger_text, res);

        // this.logger_text = `${this.logger_session} Success, redirect to payment`;
        // this.logger.debug(this.logger_text);
        this.logger.info([this.logger_text, this.motor_ucid, "Success all flow, redirect to payment"]);

        return this.redirectMethod(this.data_qr_barcode_payment.message.pmt_link);
      });
  }

  startNonMotorInsure() {
    this.logger_text = `${this.logger_session} Non-Motor Step`;
    this.logger.info(this.logger_text);
    this.getInsuranceRenewQRPayment
      .exec({
        product_type: this.ConstantsService.NONMOTOR, //  1 motor or 2 non-motor
        renewMotorUCID: this.motor_ucid,
        renewMotorLetterUCID: this.motor_letter_ucid
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "Get non-motor detail"]);
        this.logger_text = `${this.logger_session} getInsuranceRenewQRPayment: res`;
        this.logger.info(this.logger_text, res);

        this.data_1_2953 = res.result_1_2953.response_data[0];
        this.data_1_2954 = res.result_1_2954.response_data[0];
        this.data_1_9 = res.result_1_9.response_data[0];
        this.data_1_1424 = res.result_1_1424.response_data[0];

        this.logger.info([this.logger_text, this.motor_ucid, "create account"]);
        let body = this.createBodyAccount(this.data_1_2953, this.data_1_9,"nonmotor");

        this.logger_text = `${this.logger_session} createCustomerAccountService: body`;
        this.logger.info(this.logger_text, body);

        return this.createCustomerAccountService.exec(body, "");
      })
      .then(async (res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "create account res", res]);
        // this.logger_text = `${this.logger_session} createCustomerAccountService: res`;
        // this.logger.debug(this.logger_text, res);

        this.data_1_1401_1565 = res.data;

        if (this.data_1_1401_1565.accountIdentityUCID != undefined && this.data_1_1401_1565.identityUCID != undefined) {
          // data_1_2936, 1_1401_1_1565, data_1_1424 motor
          this.logger.info([this.logger_text, this.motor_ucid, "create order transaction"]);
          let body = await this.createBodyOrderTransactionAll(this.data_1_2953, this.data_1_1401_1565, this.data_1_1424);

          this.logger_text = `${this.logger_session} createBodyOrderTransactionAll: body`;
          this.logger.info(this.logger_text, body);

          return this.createOrderTransactiontService.exec(body, "");
        } else {
          this.logger_text = `${this.logger_session} Error createCustomerAccountService`;
          this.logger.error(this.logger_text);
          // this.logger.error("error createBodyAccount: ", this.createBodyAccount(this.data_1_2953, this.data_1_9));
          this.modal.show({
            title: 'Header Information',
            callBack: 'home',
            body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
          });
          return;
        }
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "create order transaction res", res]);
        // this.logger_text = `${this.logger_session} createBodyOrderTransactionAll: res`;
        // this.logger.debug(this.logger_text, res);
        this.data_order_voucher = res;

        if (this.data_order_voucher.voucherNumber != undefined && this.data_order_voucher.orderTransactionUCID != undefined) {
          let body = this.createBodyPaymentDetail(this.data_1_1401_1565, this.data_1_1424, this.data_order_voucher, this.payment_amount);
          this.logger.info([this.logger_text, this.motor_ucid, "create payment detail"]);
          this.logger_text = `${this.logger_session} createBodyPaymentDetail: body`;
          this.logger.info(this.logger_text, body);

          return this.createPaymentDetailService.exec(body);
        } else {
          this.logger_text = `${this.logger_session} Error createBodyOrderTransactionAll`;
          this.logger.info(this.logger_text);
          // this.logger.error("error createOrderTransactiontService: ", this.createBodyOrderTransactionAll(this.data_1_2953, this.data_1_1401_1565, this.data_1_1424));
          this.modal.show({
            title: 'Header Information',
            callBack: 'home',
            body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
          });
          return;
        }
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "create payment detail res", res]);
        // this.logger_text = `${this.logger_session} createPaymentDetailService: res`;
        // this.logger.debug(this.logger_text, res);

        this.data_payment_detail = res;

        let f09_status = 52;
        //step 4
        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 52"]);
        let body = this.createBodyUpdateCustomerAccount(this.data_1_2954, this.payment_amount, this.motor_ucid, this.product_type, f09_status, this.subChannel);

        this.logger_text = `${this.logger_session} createBodyUpdateCustomerAccount: body`;
        this.logger.info(this.logger_text, body);

        return this.updateCustomerPaymentQRSercice.exec(body, "");
      }).then(res => {
        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 52 res", res]);
        // this.logger_text = `${this.logger_session} createBodyUpdateCustomerAccount: res`;
        // this.logger.debug(this.logger_text, res);

        let body = this.createBodyGetDataWrapUp(this.data_1_2953._6229, this.data_1_2953._40, "M_HIP");

        this.logger_text = `${this.logger_session} createBodyGetDataWrapUp: body`;
        this.logger.info(this.logger_text, body);

        return this.getWrapUpQrPayment.exec(body);
      })
      .then(async (res: any) => {
        this.logger_text = `${this.logger_session} createBodyGetDataWrapUp: res`;
        this.logger.info(this.logger_text, res);

        this.data_wrap_up = res.data;

        let agent1 = null;
        let agent2 = null;
        if (res.data != null) {
          agent1 = this.data_wrap_up._11784;
          agent2 = this.data_wrap_up._16220;
        }
        this.logger.info([this.logger_text, this.motor_ucid, "agent1 is not null", agent1 != null ? true: false]);
        this.logger.info([this.logger_text, this.motor_ucid, "agent2 is not null", agent2 != null ? true: false]);

        let body_get_payment_summary = this.createBodyGetPaymentSummary();

        this.logger_text = `${this.logger_session} createBodyGetPaymentSummary: body`;
        this.logger.info(this.logger_text, body_get_payment_summary);

        const responseGetPaymentSummary = await this.getNonMotorPaymentSummary.exec(body_get_payment_summary);

        this.logger_text = `${this.logger_session} createBodyGetPaymentSummary: res`;
        this.logger.debug(this.logger_text, responseGetPaymentSummary);

        this.logger.info([this.logger_text, this.motor_ucid, "call f09"]);
        let body = this.createBodyF09Update(this.data_1_2953, this.data_1_2954, agent1, agent2, responseGetPaymentSummary);

        this.logger_text = `${this.logger_session} callTss: body`;
        this.logger.info(this.logger_text, body);

        return this.callTss.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "call f09 res", res]);
        // this.logger_text = `${this.logger_session} callTss: res`;
        // this.logger.debug(this.logger_text, res);

        this.data_tss = res;

        let f09_status = 51;
        try {
          if (res.response_code == "40000") {
            f09_status = 50;
          }
        } catch (e) {

        }

        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 50/51"]);
        let body = this.createBodyUpdateCustomerAccount(this.data_1_2954, this.payment_amount, this.motor_ucid, this.product_type, f09_status, this.subChannel);
        let showlogBody = {          
          status:body.status,          
          motor_ucid:body.motor_ucid,
          product_type:body.product_type
        }
        this.logger_text = `${this.logger_session} updateCustomerPaymentQRSercice: body`;
        this.logger.info(this.logger_text, showlogBody);

        return this.updateCustomerPaymentQRSercice.exec(body, "");
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "update customer account f09 50/51 res", res]);
        // this.logger_text = `${this.logger_session} updateCustomerPaymentQRSercice: res`;
        // this.logger.debug(this.logger_text, res);

        this.data_update_status = res;

        this.logger.info([this.logger_text, this.motor_ucid, "get QR payment link"]);
        let name = `${this.data_1_2953._1291} ${this.data_1_2953._1292}`;
        let service_comp_code = `Service code : 00 / Comp Code : 10`;
        let body = this.createBodyQrBarcode(this.data_1_2953._16278, this.data_1_2953._6260, this.data_1_2953._6261, name, service_comp_code);
        let showlogBody = {
          channel_app:body.channel_app,
          payment_channel:body.payment_channel,
          tax_id:this.getMaskingService.maskingData(body.tax_id),
          service_id:body.service_id,
          amount:this.getMaskingService.maskingData(body.amount),
          ref1:body.ref1,
          ref2:body.ref2,
          name:this.getMaskingService.maskingData(body.name),
          service_comp_code:body.service_comp_code
        };
        this.logger_text = `${this.logger_session} getQrBarcodePayment: body`;
        this.logger.info(this.logger_text, showlogBody);

        return this.getQrBarcodePayment.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "get QR payment link res", res]);
        // this.logger_text = `${this.logger_session} getQrBarcodePayment: res`;
        // this.logger.debug(this.logger_text, res);

        this.data_qr_barcode_payment = res;

        this.logger.info([this.logger_text, this.motor_ucid, "send line 006"]);
        let body = this.createBodyLine006();

        this.logger_text = `${this.logger_session} createBodyLine006: body`;
        this.logger.info(this.logger_text, body);

        return this.sendLineMessageService.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "send line 006 res", res]);
        // this.logger_text = `${this.logger_session} createBodyLine006: res`;
        // this.logger.debug(this.logger_text, res);

        this.logger.info([this.logger_text, this.motor_ucid, "send line 008"]);

        let body = this.createBodyLine008(this.data_qr_barcode_payment.message.pmt_link);

        this.logger_text = `${this.logger_session} createBodyLine008: body`;
        this.logger.info(this.logger_text, body);

        return this.sendLineMessageService.exec(body);
      })
      .then((res: any) => {
        this.logger.info([this.logger_text, this.motor_ucid, "send line 008", res]);
        this.logger.info([this.logger_text, this.motor_ucid, "Sucess all flow, then redirect"]);
        // this.logger_text = `${this.logger_session} createBodyLine008: res`;
        // this.logger.debug(this.logger_text, res);

        // this.logger_text = `${this.logger_session} Success, then redirect`;
        // this.logger.info(this.logger_text, res);

        return this.redirectMethod(this.data_qr_barcode_payment.message.pmt_link);
      });
  }

  createBodyAccount(user_data, data_1_9, typeofRenew) {
    let body = {
      registrationNumber: user_data._13,
      genderCode: "",
      titleCode: data_1_9._8,
      fistName: user_data._1291,
      lastName: user_data._1292,
      dateOfBirth: "",
      otherRegistrationNumber: null,
      mobile: user_data._25,
      email: null,
      maritalStatus: "",
      referenceID: user_data._40,
      renewMotor: true,
      typeofRenew : typeofRenew
    };
    return body;
  }

  // data_1_2936, 1_1401_1_1565, data_1_1424 motor
  async createBodyOrderTransactionAll(user, data_1_1401_1565, data_1_1424) {
    this.voucherNumber = await this.getVoucerId();
    let now = new Date();
    let DD = now.getDate();
    let MM = now.getMonth() + 1;
    let YYYY = now.getFullYear();
    let HH = now.getHours();
    let mm = now.getMinutes();
    let ss = now.getSeconds();
    let DD_str: string = DD < 10 ? `0${DD}` : `${DD}`;
    let MM_str: string = MM < 10 ? `0${MM}` : `${MM}`;
    let YY_str: string = `${YYYY.toString().slice(-2)}`;
    let HH_str: string = HH < 10 ? `0${HH}` : `${HH}`;
    let mm_str: string = mm < 10 ? `0${mm}` : `${mm}`;
    let ss_str: string = ss < 10 ? `0${ss}` : `${ss}`;

    var today = `${YY_str}${MM_str}${DD_str}${HH_str}${mm_str}${ss_str}`;

    let data_ref2 = user._6259 || null;
    if (data_ref2 == null) {
      if (this.isMotor) {
        data_ref2 = `${today}${user._16055.slice(-3)}`;
      } else {
        data_ref2 = `${today}${user._40.slice(-3)}`;
      }
    }

    let body = {
      accountIdentityUCID: data_1_1401_1565.accountIdentityUCID,
      orderNumber: user._6259 ? user._6259 : data_ref2,
      securityID: "RENEW",
      amount: parseFloat(this.payment_amount),
      orderStatus: 5,
      identityUCID: data_1_1401_1565.identityUCID,
      productInfoUCID: data_1_1424._1305 ? data_1_1424._1305 : null,
      sellerOrReceiverUCID: data_1_1401_1565.identityUCID,
      currency: 138,
      refNo1: user._6260 ? user._6260 : "100101018",
      refNo2: user._6259 ? user._6259 : data_ref2,
      voucherNumber: this.voucherNumber["reference"],
      renewMotor: true,
      renewMotorUCID: this.motor_ucid,
      isNonmotor: !this.isMotor
    };
    // if (this.console_print)
    //   console.log(user._6261 ? user._6261 : "0");
    return body;
  }

  getVoucerId(): Promise<any> {
    return this.genVoucherNumberService
      .exec({})
      .then((res) => {
        if (res["reference"]) {
          return { status: true, reference: res["reference"] };
        }
        return { status: false };
      })
      .catch((e) => {
        this.logger.error("error getContractReasonService: ", e);
        return { status: false, data: e };
      });
  }

  // data_1_1401_1565, data_1_1424, data_order_voucher, payment_amount
  createBodyPaymentDetail(data_1_1401_1565, data_1_1424, data_order_voucher, payment_amount) {
    const body = {
      identityUCID: data_1_1401_1565.identityUCID,
      productInfoUCID: data_1_1424._1305 ? data_1_1424._1305 : null,
      accountIdentityUCID: data_1_1401_1565.accountIdentityUCID,
      voucherNumber: data_order_voucher.voucherNumber,
      orderTransactionUCID: data_order_voucher.orderTransactionUCID,
      paymentMethod: 2,
      paymentChannel: 9, //5=cradit card , 9= qr code
      paymentProvider: 1,
      paymentAmt: parseFloat(payment_amount),
      paymentStatus: 5,
      renewMotor: true,
    };
    return body;
  }

  // data_1_2937, payment_amount, motor_ucid, product_type
  createBodyUpdateCustomerAccount(data_1_2937, payment_amount, motor_ucid, product_type, f09_status,subChannel) {
    let body = {
      // _13438: data_1_2937._13438,
      status: f09_status,
      amount: parseFloat(payment_amount),
      motor_ucid: motor_ucid,
      product_type: this.product_type,
      subchannel: subChannel
    };
    return body;
  }

  createBodyGetDataWrapUp(app_code, account_no, classify_insure) {
    let body = {
      app_code: app_code,
      account_no: account_no,
      classify_insure: classify_insure
    };

    return body;
  }

  async createBodyF09Update(user, letter, agent1, agent2, PaymentSummary) {
    // let now = new Date();
    // let DD = now.getDate();
    // let MM = now.getMonth() + 1;
    // let YYYY = now.getFullYear();
    // let DD_str: string = DD < 10 ? `0${DD}` : `${DD}`;
    // let MM_str: string = MM < 10 ? `0${MM}` : `${MM}`;
    // let YYYY_str: string = `${YYYY.toString()}`;
    // let date_today = `${DD_str}/${MM_str}/${YYYY_str}`;

    let today = new Date().getTime();
    let today_str = "";
    this.logger.info([this.logger_text,  this.motor_ucid, "today", today]);
    let convet_time_result_today: any = await this.convertTimestamp.exec({input_date: today});
    this.logger.info([this.logger_text,   this.motor_ucid, "today date raw", convet_time_result_today]);
    if(convet_time_result_today.response_code === "40000"){
      today_str = convet_time_result_today.response_data;
    }

    this.logger.info([this.logger_session, this.motor_ucid, "today str", today_str]);

    let lead_date_str = ""
    this.logger.info([this.logger_session, this.motor_ucid, "lead date", user._601]);
    let convet_time_result: any = await this.convertTimestamp.exec({input_date: user._601});
    this.logger.info([this.logger_text,   this.motor_ucid, "lead_date raw", convet_time_result]);
    if(convet_time_result.response_code === "40000"){
      lead_date_str = convet_time_result.response_data;
    }

    this.logger.info([this.logger_session, this.motor_ucid, "lead date str", lead_date_str]);

    let body = {
      app_code: this.isMotor ? user._12201 : user._6229,
      account_no: this.isMotor ? user._16055 : user._40,
      lead_date: lead_date_str,
      client_no: user._15812,
      classify_insure: this.isMotor ? "1" : "2",
      f09_update_inform: "50",
      quotation_selected: this.isMotor ? letter._13438 : undefined,
      payment_type: "2",
      payment_method: user._13249,
      payment_status: true,
      payment_amount: this.payment_amount,
      payment_summary: PaymentSummary.data,
      payment_date: today_str,
      agent1: agent1 ? agent1 : null,
      agent2: agent2 ? agent1 : null,
    };

    let body_log = {
      app_code: body.app_code,
      account_no: body.account_no,
      lead_date: body.lead_date,
      payment_date: body.payment_date,
      classify_insure: body.classify_insure,
      payment_status: body.payment_status
    }

    this.logger.info([this.logger_session, this.motor_ucid, "f09 body", body_log]);

    return body;
  }

  createBodyQrBarcode(tax_id, ref1, ref2, name, service_comp_code) {
    let body = {
      channel_app: 124,
      payment_channel: [1, 2],
      tax_id: tax_id ? tax_id.substring(0, 13) : "0107539000171",
      service_id: "00",
      amount: parseFloat(this.payment_amount).toFixed(2),
      ref1: ref1 ? ref1 : "100101018",
      ref2: ref2 ? ref2 : "12345",
      name: name,
      service_comp_code: service_comp_code
    };
    return body;
  }

  createBodyLine006 = () => {
    let templateRef = this.isCompulsory ? 'Renew-006-MOTOR-COMP' : 'Renew-006-MOTOR';
    if (this.product_type == this.ConstantsService.NONMOTOR) {
      templateRef = 'Renew-006-NONMOTOR';
    }
    if (this.console_print)
      this.logger.info(templateRef);
    let body = {
      // customerId: this.lineId,
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      channelId: this.rm_channel_id,
      templateRef: templateRef,
      // templateParameter:{
      //     LinkQRCode: url
      // }
    };
    return body;
  };

  createBodyLine008 = (url: string) => {
    let templateRef = this.isCompulsory ? 'Renew-008-MOTOR-COMP' : 'Renew-008-MOTOR';
    if (this.product_type == this.ConstantsService.NONMOTOR) {
      templateRef = 'Renew-008-NONMOTOR';
    }
    if (this.console_print)
      this.logger.info(templateRef);
    let body = {
      // customerId: this.lineId,
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      channelId: this.rm_channel_id,
      templateRef: templateRef,
      templateParameter: {
        LinkQRCode: url
      }
    };
    return body;
  };

  redirectMethod(url: string) {
    return window.location.href = url;
  }

  createBodyGetPaymentSummary() {
    return {
      "dataucid": this.motor_ucid,
      "letterucid": this.motor_letter_ucid
    };
  }
}
